module.exports = __webpack_public_path__ + "img/GLMR.8f5c2891.png";